



























import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import Trigger from '@modules/ui/triggers/Trigger'
import ActivationResourceList from '@superUI/ResourceList/ActivationResourceList'

# import DiscountTable from '@superUI/Pricing/DiscountTable'
# import UpdatePricingModelDiscountTriggerModal from '@triggers/Pricing/UpdatePricingModelDiscountTriggerModal'
# import RemovePricingModelDiscountTriggerModal from '@triggers/Pricing/RemovePricingModelDiscountTriggerModal'

settings =
  name: 'BrandInfoShow'
  components: {
    SuperContainerView,
    Back,
    Trigger,
    ActivationResourceList,
  }

  resources:
    item:
      resourceName: 'brand_info'
      slug: 'brand_infos/:brandInfoId'

  vue:
    props: ['brandInfoId']

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

    watch:
      $route: ->
        @fetchAllResources()

export default VueOptions.vue settings
